import { Button, Form, Input, Table } from 'antd';
import { usePermissionQuery } from './hooks/usePermissionsQuery';
import { useMemo } from 'react';
import { PermissionItem } from '~/types/permission';
import { RoleFormValues } from '../../types';

const rules = [{ required: true, message: 'Wajib diisi' }];

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    width: 200,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    width: 400,
  },
];

const PermissionField = () => {
  const form = Form.useFormInstance();
  const selectedIds = Form.useWatch('permissionIds', form);
  const permissions = usePermissionQuery();
  const sortedPermissions = useMemo(() => {
    const newArray = [...permissions];
    newArray.sort((a, b) => a.name.localeCompare(b.name));
    return newArray;
  }, [permissions]);

  return (
    <Form.Item name="permissionIds" label="Permissions" rules={rules}>
      <Table<PermissionItem>
        columns={columns}
        rowKey="permissionId"
        style={{ maxWidth: 600 }}
        dataSource={sortedPermissions}
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: selectedIds,
          onChange: (selectedRowKeys) => {
            form.setFieldValue('permissionIds', selectedRowKeys);
          },
        }}
        pagination={false}
      />
    </Form.Item>
  );
};

const RoleForm = ({
  loading,
  initialValues,
  onSubmit,
}: {
  loading: boolean;
  initialValues?: RoleFormValues;
  onSubmit: (values: RoleFormValues) => void;
}) => {
  return (
    <Form<RoleFormValues>
      name="roleForm"
      layout="vertical"
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      <Form.Item label="Nama role" name="roleName" rules={rules}>
        <Input placeholder="Nama role" />
      </Form.Item>
      <PermissionField />
      <Button type="primary" htmlType="submit" loading={loading}>
        Submit
      </Button>
    </Form>
  );
};

export default RoleForm;
